import * as ko from 'knockout';
import 'jquery';

import { Tooltip } from 'Core/Common/Tooltip';
import { ZIndexManager } from 'Core/Common/ZIndexManager';

// customOptions
// showHideOnlyOnHover - Restarts the tooltip on hover over the element.
// isLineClampMode - Triggers the tooltip upon reaching a certain height, used together with the ".line-clamp-ellipsis" class, but can be used without it
// showHideOnHoverWithContent - Like showHideOnlyOnHover, but allows interaction with the tooltip content and closes only when mouse leaves both element and tooltip

export class EllipsisTooltipExtention {
    private _jbox: jBox;
    private static _tooltip: Tooltip | null = null;

    static Init() {
        const self = this;
        ko.bindingHandlers.ellipsisTooltip = {
            init: (element, valueAccessor) => {
                const options = ko.unwrap(valueAccessor()).options;

                const updateEllipsisTooltip = () => {
                    if (options && options.isLineClampMode) {
                        //Used in conjunction with the ".line-clamp-ellipsis" class, but can be used without it
                        let currentEl = $(element);
                        if (
                            currentEl[0].offsetHeight < currentEl[0].scrollHeight ||
                            currentEl[0].offsetWidth < currentEl[0].scrollWidth
                        ) {
                            // your element have overflow
                            if (options.showHideOnlyOnHover || options.showHideOnHoverWithContent) {
                                self.ShowTooltip(element, valueAccessor);
                            } else {
                                self.Update(element, valueAccessor);
                            }
                        } else {
                            self.HideTooltip(options);
                        }
                    } else {
                        let currentEl = $(element),
                            parrentEl = currentEl.parent(),
                            rightCoorCurrent =
                                currentEl.offset().left + currentEl.prop('scrollWidth'),
                            rightCoorParent =
                                parrentEl.offset().left + parrentEl.prop('scrollWidth');

                        if (rightCoorCurrent > rightCoorParent) {
                            if (
                                options &&
                                (options.showHideOnlyOnHover || options.showHideOnHoverWithContent)
                            ) {
                                self.ShowTooltip(element, valueAccessor);
                            } else {
                                self.Update(element, valueAccessor);
                            }
                        } else {
                            self.HideTooltip(options);
                        }
                    }
                };

                $(document).ready(updateEllipsisTooltip);

                if (
                    options &&
                    (options.showHideOnlyOnHover || options.showHideOnHoverWithContent)
                ) {
                    $(element).on('mouseenter', function () {
                        setTimeout(updateEllipsisTooltip, 1);
                    });

                    if (options.showHideOnlyOnHover) {
                        $(element).on('mouseleave', function () {
                            setTimeout(() => {
                                self.HideTooltip(options);
                            }, 1);
                        });
                    }

                    if (options.showHideOnHoverWithContent) {
                        // namespaced event so we can remove it when tooltip closes
                        $(document).on('mousemove.ellipsisTooltip', function (e: any) {
                            if (self._tooltip) {
                                // Try to get tooltip DOM element from Tooltip API if available, otherwise fallback to common jBox wrapper selector
                                const tooltipDom = (self._tooltip as any).GetElement
                                    ? (self._tooltip as any).GetElement()
                                    : document.querySelector('.jBox-wrapper');
                                const $tooltipEl = tooltipDom ? $(tooltipDom) : $();
                                const $triggerEl = $(element);
                                const $target = $(e.target as any);
                                const targetEl = e.target as Element;

                                if ($tooltipEl.length === 0) {
                                    // if we can't find tooltip element, remove handler to avoid leaking
                                    $(document).off('mousemove.ellipsisTooltip');
                                    return;
                                }

                                if (
                                    !$tooltipEl.is(targetEl) &&
                                    $tooltipEl.has(targetEl).length === 0 &&
                                    !$triggerEl.is(targetEl) &&
                                    $triggerEl.has(targetEl).length === 0
                                ) {
                                    self.HideTooltip(options);
                                    // remove handler after hiding
                                    $(document).off('mousemove.ellipsisTooltip');
                                }
                            } else {
                                // no tooltip instance - remove handler
                                $(document).off('mousemove.ellipsisTooltip');
                            }
                        });
                    }
                }
            },
        };
    }

    private static ShowTooltip(element, valueAccessor) {
        const options = ko.unwrap(valueAccessor()) as ITooltipConfig;

        if (!element || !document.body.contains(element)) {
            return;
        }

        if (
            options &&
            options.options &&
            (options.options.showHideOnlyOnHover || options.options.showHideOnHoverWithContent)
        ) {
            const otherOptions = options.options;
            if (!this._tooltip) {
                this._tooltip = new Tooltip(element, options.content, otherOptions);
            }

            ko.utils.domNodeDisposal.addDisposeCallback(element, () => {});

            this._tooltip.Show(element);
        }
    }

    private static HideTooltip(options) {
        if (options && (options.showHideOnlyOnHover || options.showHideOnHoverWithContent)) {
            if (this._tooltip) {
                this._tooltip.Close();
                this._tooltip.Destroy();
                this._tooltip = null;
            }
            // ensure our namespaced mousemove handler is removed to avoid leaks
            $(document).off('mousemove.ellipsisTooltip');
        }
    }

    private static Update(element, valueAccessor) {
        const options = ko.unwrap(valueAccessor()) as ITooltipConfig;
        const otherOptions = options.options;
        const tooltip = new Tooltip(element, options.content, otherOptions);

        ko.utils.domNodeDisposal.addDisposeCallback(element, () => {});
    }

    static CreateEllipsisTooltipForPathRunner(record) {
        let currentNodeType = $(`#${record.Guid}_node-type`),
            currentAnchor = $(`#${record.Guid}_anchor`),
            jbox;

        if (
            !!currentAnchor.length &&
            !!currentNodeType &&
            document.body.contains(currentAnchor[0]) &&
            document.body.contains(currentNodeType[0])
        ) {
            if (
                currentAnchor.prop('offsetWidth') < currentAnchor.prop('scrollWidth') ||
                currentNodeType.prop('offsetWidth') < currentNodeType.prop('scrollWidth')
            ) {
                jbox = new jBox('Tooltip', {
                    content: `<b>${record.TypeNameTranslation || record.TypeTranslatedName || record.TypeName}:</b> ${record.TranslatedName || record.NameTranslation || record.Name}`,
                    addClass: `${record.Guid}_tooltip path-runner-tooltip`,
                    closeOnClick: true,
                    closeOnMouseleave: true,
                    target: $(`#${record.Guid}_anchor`),
                    zIndex: ZIndexManager.Instance.NextValue,
                });

                jbox.open();
                return jbox;
            }
        }
    }
}

export interface ITooltipConfig {
    content: string;
    options: any;
}
